import RequestStatus from "../model/RequestStatus";
import GetUserPreferenceResponse from "src/model/UserPreference";
import {
    GetUserPreferenceQueryComplete, GetUserPreferenceUpdateComplete,
    USER_PREFERENCE_QUERY_FAILED,
    USER_PREFERENCE_QUERY_START,
    USER_PREFERENCE_QUERY_SUCCESS,
    USER_PREFERENCE_UPDATE_FAILED,
    USER_PREFERENCE_UPDATE_START,
    USER_PREFERENCE_UPDATE_SUCCESS
} from "src/actions/UserPreferenceAction";

const initialState: GetUserPreferenceResponse = {
    requestStatus: RequestStatus.NOT_LOADED,
    data: null,
};

export default (
    state: GetUserPreferenceResponse = initialState,
    action: GetUserPreferenceQueryComplete | GetUserPreferenceUpdateComplete
): GetUserPreferenceResponse => {
    switch (action.type) {
        case USER_PREFERENCE_QUERY_START:
        case USER_PREFERENCE_UPDATE_START:
            return {
                requestStatus: RequestStatus.LOADING,
                data: null,
            };
        case USER_PREFERENCE_QUERY_SUCCESS:
        case USER_PREFERENCE_UPDATE_SUCCESS:
            return {
                requestStatus: RequestStatus.SUCCESS,
                data: action.userPreference,
            };
        case USER_PREFERENCE_QUERY_FAILED:
        case USER_PREFERENCE_UPDATE_FAILED:
            return {
                requestStatus: RequestStatus.ERROR,
                data: null,
            };
        default:
            return state;
    }
};
